import React from 'react';
import styled from 'styled-components';

export default styled.div`
  background-color: gray;
  width: 100%;
  height: 2px;
  margin-bottom: 1.5rem;
`;



// WEBPACK FOOTER //
// ./src/components/styledComponents/Line.js